import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";


import logo from "../assets/R.O.E logo White 2023 .png";
import thaiFlag from "../assets/Flag_of_Thailand.png";
import britishFlag from "../assets/Flag_of_England.png";

function Navbar() {
  return (
    <div className="navbar">
      <div className="container">
        <div className="logo-container">
          <Link to="/">
            <img className="logo" src={logo} alt="logo" />
          </Link>
          <h2>Rocha's Overseas Education</h2>
          <h1>LONDON HOUSE</h1>
          <h3>CHIANG MAI, THAILAND</h3>
        </div>

        <nav className="nav-menu">
          <ul>
            <li>
  <Link to="/" onClick={() => document.getElementById("programs").scrollIntoView({ behavior: "smooth" })}>
    Programs
  </Link>
</li>
            <li><Link to="/job-opportunity">Job Opportunities</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
          <div className="flag-container">
            <Link to="/HomePageTH">
              <img className="thaiFlag" src={thaiFlag} alt="thai_flag" />
            </Link>
            <Link to="/">
              <img className="britishFlag" src={britishFlag} alt="british_flag" />
            </Link>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Navbar;
